import React from 'react';
import * as fromProjects from 'store/Projects';

import { LazyVideo } from 'components/Video';

import { a } from '@react-spring/web';
import { useIntersect } from 'hooks/useIntersect';
import { useAnimateInSpring } from 'hooks/useAnimateInSpring';
import { initialOffset } from 'components/Animations/SpringProperties/SpringProperties';

interface IProps {
  animationReady: boolean;
  bodyContent: object;
}

export const SingleLargeVideo: React.FC<IProps> = ({ animationReady, ...props }) => {
  const bodyContent: fromProjects.IContentSingleLargeVideoSection = props.bodyContent as fromProjects.IContentSingleLargeVideoSection;

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const animateInSpring = useAnimateInSpring(inView);

  const videoWrapperStyles = {
    opacity: animateInSpring.active,
    transform: animateInSpring.active.to(x => `translateY(calc(${initialOffset(x)}))`),
  };

  return (
    <div ref={inViewRef} className='singleLargeVideoWrapper'>
      <a.div className={'mediaWrapper'} style={videoWrapperStyles}>
        <LazyVideo
          width='100%'
          height='100%'
          heightRatio={bodyContent.video.heightRatio}
          url={'/assets/video/work/' + bodyContent.video.url}
          autoPlay
          muted
          playVideo={inView}
          loop
          animateVideoIn={inView}
          animationType='reveal'
        />
      </a.div>
    </div>
  );
};
